// 🔧 index.js
// ✅ Purpose: Central registry for all LGV Seed Engine industries
// ✅ Features:
// - Registers all supported industry templates
// - Provides a single lookup point for generators and seeders
// - Makes adding new industries plug-and-play
// - Future-ready for dynamic imports and AI-generated industries
// - Fully block-commented for clarity and future devs

import { CAR_SHOW_MANIFEST } from "./car_show/manifest";
import { SAP_AI_AGENTS_CHALLENGE_MANIFEST } from "./sap_ai_agents_challenge/manifest";
import { GENERIC_EVENT_TYPE_MANIFESTS } from "./generic/manifests";

export const INDUSTRIES = {
  car_show: CAR_SHOW_MANIFEST,

  ...GENERIC_EVENT_TYPE_MANIFESTS,

  sap_ai_agents_challenge:
    SAP_AI_AGENTS_CHALLENGE_MANIFEST,
};

export const getIndustryTemplate = (
  industryKey = "car_show"
) => {
  // =====================================================
  // ✅ Resolve only explicitly registered industries.
  // =====================================================
  // Unknown keys must not silently become Car Shows. That
  // behavior can create believable but incorrect demo data.
  // Callers can now fail clearly when an industry is missing.
  // =====================================================

  return INDUSTRIES[industryKey] || null;
};
